var React = require('react');

function ArrRightDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.2992 9.31003L10.2992 0.99998L11.6992 0.99998L11.6992 11L11.6992 11.7L10.9992 11.7L0.999218 11.7L0.999219 10.3L9.30927 10.3L0.504244 1.49495L1.49419 0.505004L10.2992 9.31003Z","fill":"#303030"}));
}

ArrRightDown.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ArrRightDown;

ArrRightDown.default = ArrRightDown;
